import { Component } from '@theme/component';

/**
 * Cart Upsell Component that wraps the slideshow functionality
 * 
 * @extends {Component}
 */
export class CartUpsell extends Component {
  requiredRefs = /** @type {string[]} */ ([]);

  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }
}

if (!customElements.get('cart-upsell-component')) {
  customElements.define('cart-upsell-component', CartUpsell);
} 